/* eslint-disable no-unused-vars */
import { LeadLog } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    Leads: [],
    count: 0,
  },
  actions: {
    async fetchLogs({ commit }, options) {
      const logs = await LeadLog.fetch({ ...options })
      return logs
    },
  },
}
/* eslint-enable no-unused-vars */
